export const generateRandomAESKey = async () => {
  return await window.crypto.subtle.generateKey(
    { name: 'AES-CBC', length: 256 },
    true,
    ['encrypt']
  );
};

export const convertAESKeyToString = async (aesKey: CryptoKey) => {
  const exportedKey = await window.crypto.subtle.exportKey('raw', aesKey);

  // Convert the raw bytes to a hex string
  const keyHex = Array.from(new Uint8Array(exportedKey))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  // Ensure the key is 32 characters long
  return keyHex.slice(0, 32);
};
